// extracted by mini-css-extract-plugin
module.exports = {"title":"NewTicket_title__1-dei","content":"NewTicket_content__3jTxf","container":"NewTicket_container__3_xxB"};